import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

/**
 * Repository for the binary upload routes. The upload routes are served from
 * the server root (outside of /api), therefore the auth url is used as base
 * url. The image has to be sent as raw binary request body while the
 * content-type header holds the image mime type.
 */
export default class UploadRepository extends EntityBaseRepository {
    constructor() {
        super();
        this.axiosClient.defaults.baseURL = process.env.VUE_APP_AUTH_URL!;
    }

    public uploadDriverAvatar(payload: { id: string, image: Blob }): Promise<AxiosResponse> {
        return this.axiosClient.post(`upload/driver/${payload.id}`, payload.image, {
            headers: { 'Content-Type': payload.image.type }
        });
    }

    public uploadTaxiImage(payload: { id: string, slot: string, image: Blob }): Promise<AxiosResponse> {
        return this.axiosClient.post(`upload/taxi/${payload.id}/${payload.slot}`, payload.image, {
            headers: { 'Content-Type': payload.image.type }
        });
    }
}
